const countryFlag = {
	india: '🇮🇳',
	'south africa': '🇿🇦',
	'united kingdom': '🇬🇧',
	'united arab emirates': '🇦🇪',
	'hong kong': '🇭🇰',
	singapore: '🇸🇬',
	honduras: '🇭🇳',
	guatemala: '🇬🇹',
	'united states': '🇺🇸',
	thailand: '🇹🇭',
	australia: '🇦🇺',
	japan: '🇯🇵',
	china: '🇨🇳',
	france: '🇫🇷',
	germany: '🇩🇪',
	italy: '🇮🇹',
	spain: '🇪🇸',
	turkey: '🇹🇷',
	canada: '🇨🇦',
	brazil: '🇧🇷',
	russia: '🇷🇺',
	'south korea': '🇰🇷',
	mexico: '🇲🇽',
	netherlands: '🇳🇱',
	switzerland: '🇨🇭',
	sweden: '🇸🇪',
	norway: '🇳🇴',
	poland: '🇵🇱',
	austria: '🇦🇹',
	belgium: '🇧🇪',
	romania: '🇷🇴',
	'czech republic': '🇨🇿',
	hungary: '🇭🇺',
	slovakia: '🇸🇰',
	croatia: '🇭🇷',
	slovenia: '🇸🇮',
	serbia: '🇷🇸',
	bulgaria: '🇧🇬',
	greece: '🇬🇷',
	portugal: '🇵🇹',
	latvia: '🇱🇻',
	lithuania: '🇱🇹',
	estonia: '🇪🇪',
	denmark: '🇩🇰',
	finland: '🇫🇮',
	iceland: '🇮🇸',
	malaysia: '🇲🇾',
	vietnam: '🇻🇳',
	indonesia: '🇮🇩',
	swaziland: '🇸🇿',
	lesotho: '🇱🇸',
	pakistan: '🇵🇰',
	'el salvador': '🇪🇸',
	kazakhstan: '🇰🇿',
	jamaica: '🇯🇲',
	nigeria: '🇳🇬',
	belarus: '🇧🇾',
	uzbekistan: '🇺🇿',
	'sri lanka': '🇱🇰',
	iran: '🇮🇷',
	qatar: '🇶🇦',
	bahrain: '🇧🇭',
	oman: '🇴🇲',
	yemen: '🇾🇪',
	djibouti: '🇩🇯',
	israel: '🇮🇱',
	jordan: '🇯🇴',
	lithuania: '🇱🇹'
};

export default countryFlag;
